import React from 'react';

// Uses an SVG to display the Hexagon used in task markers
export const Hexagon = ({children, strokeWidth, ...props}) => {
  // strokeWidth = typeof strokeWidth !== 'number' ? 2 : strokeWidth;
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="36.204" height="36.609" viewBox="-1 0 33.204 36.609" aria-hidden="true">
        <path d="M932.846,243.809V231.567a5,5,0,0,0-2.5-4.33l-10.6-6.121a5,5,0,0,0-5,0l-10.6,6.121a5,5,0,0,0-2.5,4.33v12.242a5,5,0,0,0,2.5,4.33l10.6,6.121a5,5,0,0,0,5,0l10.6-6.121A5,5,0,0,0,932.846,243.809Z" transform="translate(-901.642 -219.383)" strokeWidth="2" {...props} />
      </svg>

      <span>{children}</span>
    </>
  )
}